import { GO_FORWARD, GO_BACK, SKIP_TO, CLOSE } from './actionTypes'

export const goForward = () => ({ type: GO_FORWARD })
export const goBack = () => ({ type: GO_BACK })
export const skipTo = (step) => ({ type: SKIP_TO, payload: { step } })
export const close = () => ({ type: CLOSE })
